import { useLoanCalculator } from './hooks/useLoanCalculator';
import { CollateralRow } from './components/CollateralRow';
import { LoanAmountRow } from './components/LoanAmountRow';
import { LoanDetailsPanel } from './components/LoanDetailsPanel';
import { PeriodPills } from './components/PeriodPills';
import styles from './Calculator.module.less';

interface CalculatorProps {
  currency?: string;
  currencyOptions?: string;
  amount?: string;
  focusAmount?: boolean;
  period?: string;
}

export function Calculator({ currency, currencyOptions, amount, focusAmount, period }: CalculatorProps) {
  const calc = useLoanCalculator({
    initialCurrency: currency,
    currencyOptions,
    initialAmount: amount,
    initialPeriod: period,
  });

  return (
    <div className={styles.calculator}>
      <div className={styles.inputs}>
        <LoanAmountRow
          value={calc.loanInput}
          currency={calc.currency}
          currencies={calc.availableCurrencies}
          loanBig={calc.loanBig}
          minLoan={calc.minLoan}
          maxLoan={calc.maxLoan}
          autoFocus={focusAmount}
          onValueChange={calc.onLoanInputChange}
          onBlur={calc.onLoanBlur}
          onSliderChange={calc.setLoanFromSlider}
          onCurrencyChange={calc.setCurrency}
        />
        <CollateralRow
          value={calc.collateralInput}
          collateralBig={calc.collateralBig}
          minBtc={calc.minBtc}
          midBtc={calc.midBtc}
          maxBtc={calc.maxBtc}
          onValueChange={calc.onCollateralInputChange}
          onBlur={calc.onCollateralBlur}
          onSliderChange={calc.setCollateralFromSlider}
        />
        <PeriodPills value={calc.period} options={calc.periods} onChange={calc.setPeriod} />
      </div>
      <LoanDetailsPanel
        currency={calc.currency}
        interestRate={calc.interestRate}
        maturityRepaymentValue={calc.maturityRepaymentValue}
        originationFeeRate={calc.originationFeeRate}
        isMobile={calc.isMobile}
      />
    </div>
  );
}
